export const yearMonthsBetween = (begin, end) => {
  if (!isYearMonthValid(begin) || !isYearMonthValid(end) || begin > end) {
    return [];
  }

  if (begin === end) {
    return [begin];
  }

  const yearMonths = [];
  let yearMonth = begin;

  while (yearMonth <= end) {
    yearMonths.push(yearMonth);

    yearMonth = nextYearMonth(yearMonth);
  }

  return yearMonths.filter(Boolean);
};

export const nextYearMonth = yearMonth => {
  if (!isYearMonthValid(yearMonth)) {
    return null;
  }

  return objectToYearMonth(nextYearMonthObject(yearMonthToObject(yearMonth)));
};

export const nextYearMonthObject = yearMonthObject => {
  if (!isYearMonthObjectValid(yearMonthObject)) {
    return null;
  }

  const nextYearMonthObject = { ...yearMonthObject };

  nextYearMonthObject.month++;
  if (nextYearMonthObject.month > 12) {
    nextYearMonthObject.month = 1;
    nextYearMonthObject.year++;
  }

  return nextYearMonthObject;
};

export const yearMonthToObject = yearMonth => {
  if (!isYearMonthValid(yearMonth)) {
    return null;
  }

  const parts = yearMonth.split('-');

  return {
    year: parts[0],
    month: parseInt(parts[1]),
  };
};

export const objectToYearMonth = yearMonthObject => {
  if (!isYearMonthObjectValid(yearMonthObject)) {
    return null;
  }

  return yearMonthObject.year + '-' + yearMonthObject.month.toString().padStart(2, '0');
};

export const isYearMonthValid = yearMonth => {
  if (!yearMonth || Object.prototype.toString.call(yearMonth) !== '[object String]') {
    return false;
  }

  return yearMonth.split('-').length === 2;
};

export const isYearMonthObjectValid = yearMonthObject => yearMonthObject && yearMonthObject?.year && yearMonthObject?.month;
